<template>
<div>
  <div v-for="(item, idx) in schema.fileList" :key="idx" style="margin-bottom:10px;">
    <div class="video-cover">

      <!-- style="touch-action:none" -->
      <div v-if="playIndex==idx && playIng" >
        <video-player  class="video-player-box"
          :ref="'videoPlayer-' + idx"
          :options="playerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @playing="onPlayerPlaying($event)"
          @ready="playerReadied">
  		  </video-player>
      </div>
      <div v-else @click="onPlayMp4(idx,item)">
        <img class="video-image" v-lazy="item.icon"/>
        <div class="video-play" ><van-icon name="play-circle-o"  color="#fff" size="45" /></div>
      </div>
      
    </div>
    <div class="video-title">
      <van-icon name="arrow" />{{ item.text }}
    </div>
    <div class="video-desc">{{ item.label }}</div>
  </div>
</div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
import { Dialog,Toast } from 'vant';

// require styles
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
 

export default {
  name: 'mp4Play',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  components: {
		videoPlayer
	},
  watch:{
    playingPluginIndex:function(){
      // 切换到其他组件播放时，这里就结束播放
      if(this.playingPluginIndex != this.pluginIndex){
        this.onVideoReset();
      }
      
    }
  },
  computed:{
    ...mapState(['playingPluginIndex']),
    player:function() {
      return this.$refs['videoPlayer-' + this.playIndex][0].player
    }
  },
  data:function(){
     
    return {
      playIndex:null,
      playIng:false,
      playerOptions: {
				// videojs options
				muted: false,
				language: 'zh-CN',
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [{
					type: "video/mp4",
					src: "",//"https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
				}],
				poster: null, //coverSrc
				width: document.documentElement.clientWidth,
				notSupportedMessage: "此视频暂无法播放，请稍后再试",
				// aspectRatio: '16:9',
				// fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: true, // 是否显示剩余时间
					fullscreenToggle: true  //全屏按钮
				}
			}
    }
  },
  methods:{
    ...mapMutations(['setPlayingPluginIndex']),

    onVideoReset:function(){
      if(!this.playIng){
        return ;
      }
      this.playIng = false;
      this.player.pause();
    },
    onPlayMp4:function(idx,item){
      let that = this;

      if(item.attach.id <=0 || item.attach.path ==""){
        Toast.fail('未上传视频');
        return ;
      }


      let videoSrc = item.attach.path;
      // console.log('videoSrc',item,videoSrc)

      // playerOptions
      this.playerOptions.poster =  item.icon;
      this.playerOptions.sources[0].src = videoSrc;

      //播放
      this.playIng = true;
      this.playIndex = idx;
      this.setPlayingPluginIndex(this.pluginIndex) //全局联动，用于停止其他组件播放

      //迟点要等 ref 生效
      setTimeout(() => {
        // console.log('this.player', that.player)
        // that.player.src(videoSrc);
        that.player.play();
      }, 300);
 

      
    },
    
    // listen event
		onPlayerPlay(player) {
		  // console.log('player play!', player)

      //播放
      this.playIng = true;
      // this.playIndex = idx;
      this.setPlayingPluginIndex(this.pluginIndex) //全局联动，用于停止其他组件播放

		},
		onPlayerPlaying(player) {
			// var video_duration = this.videoArray[this.playIndex].video_duration || "";
			// if(video_duration==""){
			// 	var duration = player.duration(); //视频时长
			// 	var duration = this.realFormatSecond(duration)
			// 	this.videoArray[this.playIndex].video_duration = duration;
			// 	this.feedback(this.playIndex,duration);
			// }

		},
		onPlayerPause(player) {
			// console.log('player pause!', player)
		},
		onPlayerEnded(player) {
			
			Toast.success('已播放结束');

      this.playIng = false;

		},
		// player is ready
		playerReadied(player) {
			// console.log('the player is readied', player)
			// you can use it to do something...
			// player.[methods]
		},

  }
}
</script>

<style>
.video-cover{
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
}
.video-play{
  position:absolute;
  bottom:5px;
  right: 5px;
  background-color: rgba(0,0,0,0.4);
  border-radius: 45px;
  padding:2px;
}
.video-image{
  max-width:100%; width:auto;margin:0 auto; display: block;
}
.video-title{
  font-size: 14px;
  margin-top:5px;
}
.video-desc{
  font-size: 14px;
  padding:5px 0;
  padding-left:15px;
  color:#969799;
}
</style>